exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty-msg[data-v-28c8419f] {\n  height: calc(100vh - 160px);\n  color: rgba(0, 0, 0, 0.54);\n  font-size: 14px;\n  padding-top: 152px;\n  justify-content: center;\n}\n", ""]);

// exports
